import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { Body, Item, Title } from './layout';

var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, _getPrototypeOf(Menu).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(Body, {
        style: this.props.style,
        onKeyDown: this.props.onKeyDown
      }, this.props.title && React.createElement(Title, null, this.props.title), this.props.items.filter(function (_ref) {
        var _ref$isAllowed = _ref.isAllowed,
            isAllowed = _ref$isAllowed === void 0 ? true : _ref$isAllowed;
        return isAllowed;
      }).map(function (item, index) {
        if (item.separation) {
          return React.createElement("div", {
            key: index,
            className: "border-top-medium border-shade-50"
          });
        }

        if (item.custom) {
          return item.custom({
            index: index
          });
        }

        return React.createElement("a", {
          key: index,
          download: true,
          href: item.href
        }, React.createElement(Item, {
          "data-qa": item.key,
          onRowClick: _this.props.onRowClick,
          action: item.action,
          icon: item.icon && React.createElement(item.icon, {
            className: item.className,
            size: 16
          }),
          image: item.image
        }, item.title));
      }));
    }
  }]);

  return Menu;
}(React.Component);

_defineProperty(Menu, "propTypes", {
  items: PropTypes.array.isRequired,
  title: PropTypes.string,
  onRowClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  onKeyDown: PropTypes.func
});

_defineProperty(Menu, "defaultProps", {
  onRowClick: function onRowClick() {}
});

export default Menu;